import {
  ADDPRODUCT,
  ADDTOCART,
  DECREMENT,
  INCREMENT,
  REMOVE,
} from "./actionTypes";

export const addProduct = (product) => {
  return {
    type: ADDPRODUCT,
    payload: product,
  };
};

export const addToCart = (product) => {
  return {
    type: ADDTOCART,
    payload: product,
  };
};

export const increment = (product) => {
  return {
    type: INCREMENT,
    payload: product,
  };
};
export const decrement = (product) => {
  return {
    type: DECREMENT,
    payload: product,
  };
};

export const remove = (product) => {
  return {
    type: REMOVE,
    payload: product,
  };
};
